"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_outgoing_style_1 = __importDefault(require("./uicon.arrow.outgoing.style"));
class UiconArrowOutgoing extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.0603 10.0685C20.3009 9.95291 20.5865 9.98542 20.7949 10.1522L27.7394 15.7077C27.9041 15.8395 28 16.039 28 16.25C28 16.461 27.9041 16.6605 27.7394 16.7923L20.7949 22.3478C20.5865 22.5146 20.3009 22.5471 20.0603 22.4315C19.8197 22.3158 19.6667 22.0725 19.6667 21.8056V16.9445H3.69446V15.5556H19.6667V10.6945C19.6667 10.4275 19.8197 10.1842 20.0603 10.0685ZM21.0556 12.1393V20.3607L26.1939 16.25L21.0556 12.1393Z", className: classes.fill }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M4.39 11L4.39 21L3 21L3 11L4.39 11Z", className: classes.fill }, void 0)] }), void 0));
        };
    }
}
UiconArrowOutgoing.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowOutgoing.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_outgoing_style_1.default)(UiconArrowOutgoing);
//# sourceMappingURL=uicon.arrow.outgoing.js.map